var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "linkedin_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linkedin_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.655 6.434H.64a.323.323 0 0 0-.323.323v12.898c0 .178.145.323.323.323h4.015a.323.323 0 0 0 .323-.323V6.757a.323.323 0 0 0-.323-.323ZM2.65.022A2.651 2.651 0 0 0 0 2.668a2.651 2.651 0 0 0 2.65 2.648 2.65 2.65 0 0 0 2.647-2.648A2.65 2.65 0 0 0 2.649.022ZM14.867 6.114c-1.612 0-2.804.693-3.527 1.48v-.837a.323.323 0 0 0-.323-.323H7.172a.323.323 0 0 0-.322.323v12.898c0 .179.144.323.322.323h4.006a.323.323 0 0 0 .323-.323v-6.381c0-2.15.584-2.989 2.083-2.989 1.633 0 1.763 1.343 1.763 3.1v6.27c0 .179.144.323.322.323h4.008a.322.322 0 0 0 .323-.323V12.58c0-3.197-.61-6.466-5.133-6.466Z"
  }))));
};
export default SvgLinkedin;